var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGpayicon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7324_22395)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.867 24.1961L7.49771 29.3078L2.49298 29.4137C0.9973 26.6395 0.148926 23.4656 0.148926 20.0926C0.148926 16.8311 0.942135 13.7554 2.34815 11.0471H2.34923L6.80484 11.864L8.75667 16.2929C8.34816 17.4838 8.1255 18.7623 8.1255 20.0926C8.12565 21.5365 8.38719 22.9198 8.867 24.1961Z",
    fill: "#FBBB00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.1433 16.4189C39.3692 17.6088 39.487 18.8375 39.487 20.0933C39.487 21.5015 39.3389 22.8751 39.0569 24.2001C38.0994 28.7088 35.5975 32.6458 32.1317 35.4318L32.1306 35.4308L26.5186 35.1444L25.7243 30.1861C28.024 28.8374 29.8212 26.7267 30.768 24.2001H20.2505V16.4189H39.1433Z",
    fill: "#518EF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.1305 35.4307L32.1315 35.4318C28.7609 38.1411 24.479 39.7622 19.818 39.7622C12.3276 39.7622 5.81528 35.5755 2.49316 29.4144L8.86719 24.1968C10.5282 28.6298 14.8046 31.7855 19.818 31.7855C21.9729 31.7855 23.9917 31.203 25.724 30.186L32.1305 35.4307Z",
    fill: "#28B446"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.3724 4.95197L26.0005 10.1685C24.2076 9.04786 22.0883 8.40048 19.8178 8.40048C14.6909 8.40048 10.3346 11.7009 8.75674 16.2929L2.34922 11.0472H2.34814C5.62163 4.73585 12.2161 0.423828 19.8178 0.423828C24.5902 0.423828 28.966 2.1238 32.3724 4.95197Z",
    fill: "#F14336"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7324_22395"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 39.3377,
    height: 39.3377,
    fill: "white",
    transform: "translate(0.148926 0.423828)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGpayicon);
export default __webpack_public_path__ + "static/media/gpayicon.f5c2a9fccf084acd4fa3b8bda0a575f8.svg";
export { ForwardRef as ReactComponent };